<template>
  <div :class="classesRoot">
    <div :class="$style.head">
      <div :class="$style.name">
        {{ day.shortName + ' ' + formatDate(day.date) }}
      </div>
    </div>

    <template v-if="schedule.length">
      <div
        v-for="(timeElement, index) in schedule"
        :key="`${day.date}-${index}`"
        :class="$style.item"
      >
        <UiButton
          :class="{
            [$style.button]: true,
            [$style.timeText]: true,
            [$style.isHighlighted]: timeElement.ui.isHighlighted,
          }"
          :theme="timeElement.ui.buttonTheme"
          :disabled="timeElement.ui.isDisabled"
          :fluid="true"
          :text-align="timeElement.ui.buttonTextAlign"
          :inner-style="timeElement.ui.buttonInnerStyle"
          :style="timeElement.ui.buttonStyle"
          v-bind="timeElement.ui.buttonProps"
          @click.stop="handleShowDropdown(day, timeElement)"
        >
          <slot
            :day="day"
            :time-element="timeElement"
            name="button-content"
          >
            <span :class="$style.timeTextInner">
              {{ timeElement.from }}</span>
          </slot>
        </UiButton>

        <CalendarLessonsDayDropdown
          v-if="timeElement.ui.isShowDropdown"
          :class="$style.dropdown"
          :opened="timeElement.ui.dropdownIsOpened"
          :outline="timeElement.ui.dropdownIsOutline"
          :content-style="timeElement.ui.dropdownContentStyle"
          @close="handlerCloseDropdown"
        >
          <template #heading>
            <slot
              :day="day"
              :time-element="timeElement"
              name="button-content"
            >
              {{ timeElement.from }}
            </slot>
          </template>

          <template #date />

          <template #default>
            <slot
              :day="day"
              :time-element="timeElement"
              name="dropdown-content"
            />
          </template>
        </CalendarLessonsDayDropdown>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UiButton from '@/components/UiButton';
import CalendarLessonsDayDropdown from '@/components/CalendarLessons/CalendarLessonsDayDropdown';

export default {
  name: 'CalendarLessonsDay',
  components: {
    UiButton,
    CalendarLessonsDayDropdown,
  },
  props: {
    day: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      isFiltered: 'calendar/getFilter',
      currentDateTime: 'calendar/getCurrentDateTime',
    }),

    schedule() {
      return this.day.schedule || [];
    },

    classesRoot() {
      const { $style } = this;
      return {
        [$style.root]: true,
        [$style.isFiltered]: this.isFiltered,
        [$style.isOpenedDropdown]: this.currentDateTime,
      };
    },
  },
  methods: {
    formatDate(date) {
     return `${date.split('.')[0]}.${date.split('.')[1]}`;
    },
    handleShowDropdown(day, timeElement) {
      const { date } = day;
      const {
        ui,
        from: time,
      } = timeElement;

      if (!ui.isShowDropdown) {
        this.handlerCloseDropdown();
        return;
      }

      this.$store.dispatch('calendar/setCurrentDateTime', {
        date,
        time,
      });
    },

    handlerCloseDropdown() {
      this.$store.dispatch('calendar/resetCurrentDateTime');
    },
  },
};
</script>

<style lang="scss" module>
.root {
  @include paddingX(8px);

  &:last-child {
    border-right: none;
  }
}
.timeText {
  font-weight: 400 !important;
  font-variant-numeric: lining-nums tabular-nums !important;
  font-family: $fontFamilyInter !important;
}
.head {
  margin-bottom: 15px;
  text-align: center;
}

.name {
  margin-bottom: 3px;
  @include typography(20px, 20px);
  font-weight: 500;
}

.date {
  @include typography(15px, 20px);
}

.item {

  margin-bottom: 10px;
  position: relative;
}

.button {
  padding: 6px 0 6px 0;
  background-color: $colorGray;
  border-radius: 10px;

  .isOpenedDropdown & {
    filter: opacity(50%) grayscale(70%);

    &:hover {
      filter: unset;
    }
  }

  .isFiltered & {
    &:not(.isHighlighted) {
      filter: opacity(25%) grayscale(100%);
      color: $colorGrayDark;
    }
  }
}

.dropdown {
  position: absolute;
  top: 0;
  right: 0;
  left: -7.5%;
  z-index: 10;
}
.timeTextInner {
  position: relative;
}

</style>
